import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class AccountListService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	// Buscar AccountClientList
	getAccountClient(token, id, name, doc, nickname, group, orderNumber, orderby, sort, page) {

		var params = {
			CodigoPrincipal: id,
			Nome: name,
			Documento: doc,
			Apelido: nickname,
			GrupoEconomico: group,
			NumeroOrdem: orderNumber,
		};

		console.log(params);

		page = page * globalConst.paginationSkip;

		return this.http
			.post(this.apiUrl + "/accounts/v1/searchcustomer?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/service/account-client-list/account-client-list.service.ts